module.exports = __webpack_public_path__ + "static/img/banner_solutions_optics.829c728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/solution/banner_solutions_optics.png
// module id = GM7X
// module chunks = 10